import PolicyPage from "@/components/legal/PolicyPage";
import { POLICY_PAGES } from "@/constants/policies";

export default function RefundPolicy() {
  return <PolicyPage policy={POLICY_PAGES.refund} />;
}
